const PAYMENTS_DISABLED_CODE = 'payments_disabled_by_admin'

/**
 * Pre-payment UX guard: reload the page when an admin has disabled payments
 */
export const reloadIfPaymentsDisabled = (resource) => {
  if (resource?.unavailability_reason?.code !== PAYMENTS_DISABLED_CODE) return false

  window.location.reload()
  return true
}
